import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App.js";
import "./styles/tokens.css";

// Initialize Telegram WebApp SDK if available
if (window.Telegram?.WebApp) {
  window.Telegram.WebApp.ready();
  window.Telegram.WebApp.expand();
}

const rootElement = document.getElementById("root");
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
